import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { WeatherTropicalStormSvgComponent } from './weather-tropical-storm-legend/weather-tropical-storm-legend-svg';

export const WEATHER_TROPICAL_STORM_LEGEND: TwcLegendParams = {
  title: 'TROPICAL CYCLONE TRACKS',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: WeatherTropicalStormSvgComponent },
  legendComponent: TwcLegendComponent
};
